import React from "react";
import { Link } from "react-router-dom";
import { Button } from "semantic-ui-react";
import { Trans, useTranslation } from "react-i18next";

import Styles from "../../SleepingCustomer.module.scss";
import { Icon } from "@/shared/components";
import { csFormPageGasUrl, csFormPageStormUrl } from "@/routes/changeservice";


const ActivateNewCs = ({ category: { categoryName, slug } }: { category: { categoryName: string, slug: string } }) => {
  const { t } = useTranslation();
  const invertedCategoryName = categoryName === "Gas" ? "Strom" : "Gas";
  const invertedSlug = slug === "gas" ? "strom" : "gas";

  return (
    <div className={`${Styles.activateNewCS} theme-bgcolor-primary`}>
      <div className={Styles.iconText}>
        <div className={Styles.icon}>{invertedCategoryName === "Gas" ? <Icon name="gas" size="40" /> : <Icon name="electricity" size="40" />}</div>
        <div className={Styles.text}>
          <Trans
            i18nKey={"changeservice.benefits.title"}
            values={{ categoryName: invertedCategoryName }}
          >
            <br />
          </Trans>
        </div>
      </div>
      <div>
        <Link to={invertedSlug == "gas" ? csFormPageGasUrl : csFormPageStormUrl}>
          <Button color="black" size="small" id="activateButton">
            {t("changeservice.benefits.cta", { categoryName: invertedCategoryName })}
            <i aria-hidden="true" className="arrow right icon"></i>
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default ActivateNewCs;
